module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/banner-aai-f4e948d8432411957f126c757682aa91.png";